module.exports = __webpack_public_path__ + "img/cart.2aaea0e.svg?v=1763034624171";